module.exports = "query GetBanners {\n  banners {\n    __typename\n    id\n    title\n    htmlContent\n    createdAt\n    updatedAt\n  }\n}\n"